import gql from "graphql-tag";

export const ToggleProject = gql`
  mutation ToggleProject($id: String!) {
  toggleProject(projectId: $id) {
    id
  }
}
`;
